<style lang="scss" scoped>
 /deep/ .ivu-table{
    background-color: hsla(0,0%,100%,.1)!important;
   th{
     border: 0px !important;
   }
   td {
     background-color: #041936;
     transition: background-color .2s ease-in-out;
     color: #E4EFF5;
     border: none;
   }
  }
 /deep/ .ivu-table-tbody tr:nth-child(2n) td{
   background: #0C2745;
 }
 /deep/ .ivu-table:before {
   content: "";
   position: absolute;
   background-color: #041936 !important;
 }
  /deep/ .ivu-table-header thead tr th{
    background-color: #0C2745;
    color: #7DB4DB;
  }

.no-results {
  text-align: center;
  text-align: center;
  line-height: 100px;
  font-size: 14px;
  color: #08f4f7;
}
.loading{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.3);
  img{
    width: 200px;
  }
}
</style>
<template>
<div>
  <div class="no-results" v-if="noData">未查询到该设备的检查记录</div>
  <div class="loading" v-show="loading_status">
        <!-- 加载动画 -->
        <div class="loading_box" v-show="!oneData.length">
            <img :src="tableLoad" />
        </div>
        <div class="more_data_box" v-show="oneData.length">
            <img :src="tableMore" />
        </div>
    </div>
  <div v-if="resultOnOff">
    <Table :columns="columns10" :data="oneData"></Table>
  </div>
</div>

</template>
<script>
import expandRow from "./table-expand.vue";

import tableLoad from '@/assets/img/animation.gif';
import tableMore from '@/assets/img/animation.gif';
export default {
  name: "unquantize-record",
  components: {
    expandRow
  },
  data() {
    return {
      loading_status: false,
      noData: false,
      tableLoad,
      tableMore,
      deviceIds:'',
      oneData: [],
      resultOnOff: false,
      columns10: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
                deviceId:this.deviceId
              }
            });
          }
        },
        {
          title: "排查项名称",
          key: "standardName",
          render: (h, params) => {
            let arr = [
              h("span", {}, this.oneData[params.index].standardName),
              h("img", {
                attrs: {
                  src: `http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/new.png`
                }
              })
            ];
            return h("div", arr);
          }
        },
        {
          title: "排查时间",
          key: "recordTime",
          render: (h, params) => {
            let arr = [
              h(
                "span",
                {},
                `${this.timestampToTime(this.oneData[params.index].recordTime)}`
              )
            ];
            return h("div", arr);
          }
        },
        {
          title: "排查人",
          key: "patrolName"
        },
        {
          title: "排查结果",
          key: "result"
        },
        {
          title: "是否隐患",
          key: "hiddenDanger",
          render: (h, params) => {
            let arr = [
              h("img", {
                attrs: {
                  src: `${this.dangerTrans(
                    this.oneData[params.index].hiddenDanger
                  )}`
                }
              })
            ];
            return h("div", arr);
          }
        }
      ]
    };
  },
  props: ["type","deviceId"],
  mounted() {
      this.deviceIds=this.deviceId;
      this.getOneData();
  },
  watch: {
/*    '$route'(to, from) {
      this.deviceId = this.$route.query.id;
      //this.getOneData();
    }*/
  },
  methods: {
      // 获取一级数据
    getOneData() {
        this.resultOnOff = false;
        this.noData = false;
        this.loading_status = true;
        let url='mcbw/patrol_records/current';
        var data = {
            type: 'get',
            url: url,
            obj: {
                patrolStandardType:this.type,
                deviceId:this.deviceId
            }
        };
        this.$Axios(data).then((res) => {
            this.loading_status = false;
            if (res.data.success) {
                if (res.data) {
                    this.oneData = res.data.data;
                    if (this.oneData.length == 0) {
                        this.resultOnOff = false;
                        this.noData = true;
                    } else {
                        this.resultOnOff = true;
                        this.noData = false;
                    }
                }
            }else {
              this.noData = true;
            }
        });
    },
    dangerTrans(val) {
      if (val == 1) {
        return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/baojing.png";
      } else if (val == 0) {
        return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/zhengchang.png";
      }
    },
    timestampToTime(timestamp) {
      // 转换时间戳
      if (timestamp == null) {
        return "";
      } else {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D + h + m + s;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/unquantize-record.vue